export var SET_MAKE_PAYMENT_ADDRESSES = 'SET_MAKE_PAYMENT_ADDRESSES';
export var SET_MAKE_PAYMENT_INSTRUMENT = 'SET_MAKE_PAYMENT_INSTRUMENT';
export var SET_PAYMENT_INSTRUMENT_SELECTED_CARD_TYPE = 'SET_PAYMENT_INSTRUMENT_SELECTED_CARD_TYPE';
export var SET_MAKE_PAYMENT_INSTRUMENT_BILLING_ADDRESS = 'SET_MAKE_PAYMENT_INSTRUMENT_BILLING_ADDRESS';
export var SET_MAKE_PAYMENT_ADDRESS_STATE_VALUE = 'SET_MAKE_PAYMENT_ADDRESS_STATE_VALUE';
export var setMakePaymentAddresses = function setMakePaymentAddresses(addresses) {
  return {
    type: SET_MAKE_PAYMENT_ADDRESSES,
    payload: addresses
  };
};
export var setMakePaymentAddressStateValue = function setMakePaymentAddressStateValue(stateValue) {
  return {
    type: SET_MAKE_PAYMENT_ADDRESS_STATE_VALUE,
    payload: stateValue
  };
};
export var setMakePaymentInstrument = function setMakePaymentInstrument(paymentInstrument) {
  return {
    type: SET_MAKE_PAYMENT_INSTRUMENT,
    payload: paymentInstrument
  };
};
export var setPaymentInstrumentSelectedCardType = function setPaymentInstrumentSelectedCardType(paymentInstrument) {
  return {
    type: SET_PAYMENT_INSTRUMENT_SELECTED_CARD_TYPE,
    payload: paymentInstrument
  };
};
export var setMakePaymentInstrumentBillingAddress = function setMakePaymentInstrumentBillingAddress(billingAddress) {
  return {
    type: SET_MAKE_PAYMENT_INSTRUMENT_BILLING_ADDRESS,
    payload: billingAddress
  };
};